var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login_tips"},[_c('h4',[_vm._v("登录")]),_vm._v(" "),_c('p',{on:{"click":function($event){return _vm.toContinue()}}},[_vm._v("继续登录")]),_vm._v(" "),_c('p',{on:{"click":function($event){return _vm.checkBack()}}},[_vm._v("返回上一页")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13fa02c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/viewsNew/Login.vue
// module id = null
// module chunks = 